import _regeneratorRuntime from "/codebuild/output/src748241224/src/github.com/EverlyWell/www/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import { __awaiter } from "tslib";
import React from "react";
import { useTransition } from "react-spring";
import * as S from "./styles";
var customConfig = {
  mass: 1,
  tension: 120,
  friction: 50,
  precision: 1e-4
};
export function HeroSlide(_ref) {
  var _this = this;

  var e = _ref.image,
      t = _ref.imageAlt,
      a = _ref.activeSlide,
      i = _ref.direction,
      _ref$firstLoad = _ref.firstLoad,
      n = _ref$firstLoad === void 0 ? !1 : _ref$firstLoad;
  var o = useTransition(e, {
    config: Object.assign(Object.assign({}, customConfig), {
      friction: .9 * customConfig.friction
    }),
    from: {
      transform: "right" === i ? "translate3d(-125%, 0, 0)" : "translate3d(125%, 0, 0)"
    },
    enter: function enter() {
      return function (e) {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return e({
                    transform: "right" === i ? "translate3d(-125%, 0, 0)" : "translate3d(125%, 0, 0)",
                    position: "absolute",
                    immediate: !0
                  });

                case 2:
                  _context.next = 4;
                  return e({
                    transform: "translate3d(0%, 0, 0)",
                    delay: 200
                  });

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
      };
    },
    leave: function leave() {
      return function (e) {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return e({
                    transform: "right" === i ? "translate3d(125%, 0, 0)" : "translate3d(-125%, 0, 0)",
                    position: "absolute"
                  });

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
      };
    },
    key: a
  }),
      r = "object" == typeof e;
  return React.createElement(S.Slide, null, React.createElement(S.ImageContainer, null, n && r && React.createElement(S.ImageComponentContainer, null, e), n && !r && React.createElement(S.Image, {
    alt: t,
    src: e
  }), !n && o(function (e, a, i) {
    return "object" == typeof a ? React.createElement(S.ImageComponentContainer, {
      key: i,
      style: e
    }, a) : React.createElement(S.Image, {
      key: i,
      style: e,
      alt: t,
      src: a
    });
  })));
}
export default HeroSlide;